// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Goods Receipt Tabs Styling */
.grn-tabs .nav-link {
  border: 1px solid transparent;
  color: var(--bs-secondary-color);
  font-weight: 500;
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.grn-tabs .nav-link:hover {
  color: var(--bs-primary);
  background: rgba(13, 110, 253, 0.06);
}

.grn-tabs .nav-link.active {
  color: var(--bs-primary);
  background: #fff;
  border-color: rgba(15, 23, 42, 0.08);
  border-bottom-color: #fff;
  margin-bottom: -1px;
}

.grn-tabs-content {
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  border-top: none !important;
  border-radius: 0 0 0.75rem 0.75rem !important;
  background: #fff;
  padding: 1.5rem;
  min-height: 400px;
}

.grn-detail-tabs .grn-catch-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.35rem;
  margin-left: 0.45rem;
  padding: 0 0.4rem;
  border-radius: 999px;
  background: rgba(43, 57, 145, 0.12);
  color: #2b3991;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.35rem;
}

.grn-detail-tabs .nav-link.active .grn-catch-count {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.grn-catch-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}

.grn-catch-summary > div {
  padding: 14px 16px;
  border-radius: 14px;
  background: linear-gradient(180deg, #f7f8fd 0%, #eef1f8 100%);
  border: 1px solid #e6e8f2;
}

.grn-catch-summary span {
  display: block;
  margin-bottom: 4px;
  color: #6b7280;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.grn-catch-summary strong {
  color: #111827;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.grn-catch-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.grn-catch-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  max-width: 420px;
  padding: 0 12px;
  border: 1px solid #e6e8f2;
  border-radius: 12px;
  background: #fff;
}

.grn-catch-search i {
  color: #6b7280;
}

.grn-catch-search input {
  width: 100%;
  border: 0;
  outline: 0;
  padding: 10px 0;
  background: transparent;
  color: #111827;
  font-size: 0.92rem;
}

.grn-catch-shown {
  color: #6b7280;
  font-size: 0.82rem;
  font-weight: 600;
}

.grn-catch-table-wrap {
  overflow: auto;
  max-height: 460px;
  border: 1px solid #dee2e6;
  border-radius: 0;
  background: #fff;
}

.grn-catch-table {
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}

.grn-catch-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 6px 8px;
  background: #f8f9fa;
  color: #212529;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.25;
  text-align: left;
  border: 1px solid #dee2e6;
  white-space: nowrap;
  overflow: hidden;
}

.grn-catch-th-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 6px;
}

.grn-catch-col-resizer {
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 100%;
  cursor: col-resize;
  z-index: 3;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}

.grn-catch-col-resizer:hover,
.grn-catch-col-resizer.is-active {
  background: rgba(30, 113, 187, 0.35);
}

.grn-catch-table td {
  padding: 4px 8px;
  color: #212529;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.25;
  border: 1px solid #dee2e6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.grn-catch-table tbody tr:hover td {
  background: #f8f9fd;
}

.grn-catch-table .is-numeric {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.grn-catch-serial {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef0fa;
  color: #2b3991;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.grn-catch-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 220px;
  border: 1px dashed #d8dce8;
  border-radius: 0;
  background: #f8f9fc;
  color: #6b7280;
}

.grn-catch-empty i {
  font-size: 1.6rem;
  color: #2b3991;
}

.grn-catch-empty p {
  margin: 0;
}

@media (max-width: 720px) {
  .grn-catch-summary {
    grid-template-columns: 1fr;
  }

  .grn-catch-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .grn-catch-search {
    max-width: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Grn/goods-receipt.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,4EAA4E;AAC9E;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,6CAA6C;EAC7C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qEAAqE;EACrE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Goods Receipt Tabs Styling */\n.grn-tabs .nav-link {\n  border: 1px solid transparent;\n  color: var(--bs-secondary-color);\n  font-weight: 500;\n  font-size: 0.875rem;\n  padding: 0.5rem 1rem;\n  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.grn-tabs .nav-link:hover {\n  color: var(--bs-primary);\n  background: rgba(13, 110, 253, 0.06);\n}\n\n.grn-tabs .nav-link.active {\n  color: var(--bs-primary);\n  background: #fff;\n  border-color: rgba(15, 23, 42, 0.08);\n  border-bottom-color: #fff;\n  margin-bottom: -1px;\n}\n\n.grn-tabs-content {\n  border: 1px solid rgba(15, 23, 42, 0.08) !important;\n  border-top: none !important;\n  border-radius: 0 0 0.75rem 0.75rem !important;\n  background: #fff;\n  padding: 1.5rem;\n  min-height: 400px;\n}\n\n.grn-detail-tabs .grn-catch-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.35rem;\n  margin-left: 0.45rem;\n  padding: 0 0.4rem;\n  border-radius: 999px;\n  background: rgba(43, 57, 145, 0.12);\n  color: #2b3991;\n  font-size: 0.72rem;\n  font-weight: 700;\n  line-height: 1.35rem;\n}\n\n.grn-detail-tabs .nav-link.active .grn-catch-count {\n  background: rgba(255, 255, 255, 0.22);\n  color: #fff;\n}\n\n.grn-catch-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.grn-catch-summary > div {\n  padding: 14px 16px;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #f7f8fd 0%, #eef1f8 100%);\n  border: 1px solid #e6e8f2;\n}\n\n.grn-catch-summary span {\n  display: block;\n  margin-bottom: 4px;\n  color: #6b7280;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.grn-catch-summary strong {\n  color: #111827;\n  font-size: 1.25rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.grn-catch-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.grn-catch-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  max-width: 420px;\n  padding: 0 12px;\n  border: 1px solid #e6e8f2;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.grn-catch-search i {\n  color: #6b7280;\n}\n\n.grn-catch-search input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  padding: 10px 0;\n  background: transparent;\n  color: #111827;\n  font-size: 0.92rem;\n}\n\n.grn-catch-shown {\n  color: #6b7280;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.grn-catch-table-wrap {\n  overflow: auto;\n  max-height: 460px;\n  border: 1px solid #dee2e6;\n  border-radius: 0;\n  background: #fff;\n}\n\n.grn-catch-table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed;\n}\n\n.grn-catch-table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 6px 8px;\n  background: #f8f9fa;\n  color: #212529;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0;\n  line-height: 1.25;\n  text-align: left;\n  border: 1px solid #dee2e6;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.grn-catch-th-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 6px;\n}\n\n.grn-catch-col-resizer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n  cursor: col-resize;\n  z-index: 3;\n  user-select: none;\n  touch-action: none;\n}\n\n.grn-catch-col-resizer:hover,\n.grn-catch-col-resizer.is-active {\n  background: rgba(30, 113, 187, 0.35);\n}\n\n.grn-catch-table td {\n  padding: 4px 8px;\n  color: #212529;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.25;\n  border: 1px solid #dee2e6;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.grn-catch-table tbody tr:hover td {\n  background: #f8f9fd;\n}\n\n.grn-catch-table .is-numeric {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.grn-catch-serial {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #eef0fa;\n  color: #2b3991;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n}\n\n.grn-catch-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 220px;\n  border: 1px dashed #d8dce8;\n  border-radius: 0;\n  background: #f8f9fc;\n  color: #6b7280;\n}\n\n.grn-catch-empty i {\n  font-size: 1.6rem;\n  color: #2b3991;\n}\n\n.grn-catch-empty p {\n  margin: 0;\n}\n\n@media (max-width: 720px) {\n  .grn-catch-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .grn-catch-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .grn-catch-search {\n    max-width: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
